// extracted by mini-css-extract-plugin
module.exports = {"shadowed":"Home_shadowed__GXRih","hand":"Home_hand__u4sN9","wave":"Home_wave__1cQtJ"};